import React from 'react';
import { withRouter } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

import RegistrationHeader2 from '../common/components/RegistrationHeader2.js';
import RegistrationFooter2 from '../common/components/RegistrationFooter2.js';

const Registration2ThankYou = (props) => {

	const {
		location
	} = props;

	// let type = '';

	let lessonLocation = '';
	const queryParameters = new URLSearchParams(location.search);

	/*
	if(queryParameters.has('type')) {
		type = queryParameters.get('type');
	}
	*/

	if(queryParameters.has('lessonLocation')) {
		lessonLocation = queryParameters.get('lessonLocation');
	}

	let displayText = null;
	displayText = <p>Thank you for registering for lessons.  A member of our staff will contact you shortly.</p>;

  let paymentText = null;
  paymentText = (
    <React.Fragment>
      <p>
        To complete your registration, you will need to set up a payment method for lessons.  Your method of payment will only be charged once you have booked a time slot. Please email us for possible time slots if you haven't already. We do not charge a registration fee, but do require a card or account on file to register. We use Stripe - the industry leader in safe, protected online payments.
      </p>
      <p>
        You can choose to use a bank account (no fees) or a credit card (3.35% fee)<br />
        To do this - choose Bank Account or Credit/Debit and fill out both forms for the method you prefer.
      </p>
      <p>
        <a href='https://forms.gle/MWh3NWBPpMA6JS4a8' target='_blank' rel='noreferrer'>Bank Account: Form One of Two</a><br />
        <a href='https://forms.gle/rLGGotVj8uwMVn8bA' target='_blank' rel='noreferrer'>Bank Account: Form Two of Two</a>
      </p>
      <p>
        <a href='https://forms.gle/gtMDvUBzSFfcHDr76' target='_blank' rel='noreferrer'>Credit/Debit Card: Form One of Two</a><br />
        <a href='https://forms.gle/qBESaNf3yVDUzNJA7' target='_blank' rel='noreferrer'>Credit/Debit Card: Form Two of Two</a><br />
      </p>
    </React.Fragment>
  );
	return (
		<React.Fragment>
			<MetaTags>
				<title>Thank You</title>
				<meta name="description" content="Thank You for Registering"/>
				<meta property="og:title" content="Thank You for Registering" />
			</MetaTags>
			<RegistrationHeader2 lessonLocation={lessonLocation} />
			<main>
				<div className='content'>
					<div className='pageContent'>
						<h1>Thank You</h1>
						{displayText}
            			{paymentText}
					</div>
				</div>
			</main>
			<RegistrationFooter2 lessonLocation={lessonLocation} />
		</React.Fragment>
	);
};

export default withRouter(Registration2ThankYou);
